<template>
  <el-container class="admin-shell">
    <el-menu class="admin-menu" unique-opened router :background-color="menuBg" :text-color="menuText" :active-text-color="menuActive">
      <div class="admin-logo">Hello Pix 超管</div>
      <el-menu-item index="/admin/dashboard"><i class="el-icon-data-analysis"></i><span slot="title">总览</span></el-menu-item>
      <el-menu-item index="/admin/users"><i class="el-icon-user"></i><span slot="title">商户管理</span></el-menu-item>
      <!-- 工单放一级菜单：客服每天都要看，塞进二级用户会漏消息 -->
      <el-menu-item index="/admin/tickets">
        <i class="el-icon-chat-dot-square"></i>
        <span slot="title">工单<el-badge v-if="ticketUnread > 0" :value="ticketUnread" :max="99" class="ticket-badge"></el-badge></span>
      </el-menu-item>
      <el-submenu index="ops">
        <template slot="title"><i class="el-icon-s-operation"></i><span>运营</span></template>
        <el-menu-item index="/admin/orders">全部工单</el-menu-item>
        <el-menu-item index="/admin/accounts">在线账号</el-menu-item>
        <el-menu-item index="/admin/fans">进粉统计</el-menu-item>
        <el-menu-item index="/admin/links">分流链接</el-menu-item>
        <el-menu-item index="/admin/scripts">话术回复</el-menu-item>
      </el-submenu>
      <el-submenu index="billing">
        <template slot="title"><i class="el-icon-wallet"></i><span>计费</span></template>
        <el-menu-item index="/admin/packages">套餐管理</el-menu-item>
        <el-menu-item index="/admin/recharges">充值流水</el-menu-item>
        <el-menu-item index="/admin/translate">翻译计费</el-menu-item>
        <el-menu-item index="/admin/engines">翻译通道</el-menu-item>
      </el-submenu>
      <el-submenu index="sys">
        <template slot="title"><i class="el-icon-setting"></i><span>系统</span></template>
        <el-menu-item index="/admin/notices">公告管理</el-menu-item>
        <el-menu-item index="/admin/clients">客户端版本</el-menu-item>
        <el-menu-item index="/admin/support">帮助与客服</el-menu-item>
        <el-menu-item index="/admin/verify">验证码接口</el-menu-item>
        <el-menu-item index="/admin/settings">系统设置</el-menu-item>
        <el-menu-item index="/admin/logs">登录与审计</el-menu-item>
        <el-menu-item index="/admin/staff">超管账号</el-menu-item>
      </el-submenu>
    </el-menu>
    <el-container>
      <el-header class="admin-header">
        <span>{{ $route.name }}</span>
        <span class="admin-header-right">
          <theme-toggle></theme-toggle>
          {{ admin.nickname || admin.username }}
          <el-button type="text" @click="logout">退出</el-button>
        </span>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import ThemeToggle from '../ThemeToggle.vue'
// 侧栏配色跟随主题：日间用浅色侧栏，夜间用深色（原来的固定深色）
export default {
  components: { ThemeToggle },
  data() {
    return { dark: document.documentElement.getAttribute('data-theme') === 'dark', ticketUnread: 0 }
  },
  computed: {
    admin() {
      return this.$store.state.admin || {}
    },
    menuBg() {
      return this.dark ? '#111827' : '#ffffff'
    },
    menuText() {
      return this.dark ? '#cbd5e1' : '#5b6675'
    },
    menuActive() {
      return this.dark ? '#fca5a5' : '#1677ff'
    }
  },
  methods: {
    // 主题变化时同步侧栏配色（ThemeToggle 直接改的是 <html> 属性）
    syncDark() {
      this.dark = document.documentElement.getAttribute('data-theme') === 'dark'
    },
    logout() {
      this.postRequest('/admin/logout')
      this.$store.commit('adminLogout')
      this.$router.replace('/admin/login')
    },
    // 未读工单数：只回一个数字，60s 拉一次就够。
    // 页面在后台时不发请求 —— 客服挂着标签页去吃饭，不该一直空转打数据库。
    fetchTicketUnread() {
      if (document.hidden) return
      this.getRequest('/admin/tickets-unread').then(resp => {
        if (resp && resp.status == 200 && resp.data) {
          this.ticketUnread = Number(resp.data.unread) || 0
        }
      }).catch(() => {})
    },
    // 工单页打开某张票后会派发这个事件，让侧栏立刻掉数字，
    // 不必等下一次轮询（否则客服点进去看完红点还在，很别扭）
    onTicketRead() {
      this.fetchTicketUnread()
    },
    onVisibility() {
      if (!document.hidden) this.fetchTicketUnread()
    }
  },
  mounted() {
    document.addEventListener('pix-theme-change', this.syncDark)
    document.addEventListener('visibilitychange', this.onVisibility)
    window.addEventListener('pix-ticket-read', this.onTicketRead)
    this.fetchTicketUnread()
    this.ticketTimer = setInterval(this.fetchTicketUnread, 60000)
  },
  beforeDestroy() {
    document.removeEventListener('pix-theme-change', this.syncDark)
    document.removeEventListener('visibilitychange', this.onVisibility)
    window.removeEventListener('pix-ticket-read', this.onTicketRead)
    if (this.ticketTimer) clearInterval(this.ticketTimer)
  }
}
</script>
<style scoped>
.admin-shell {
  height: 100%;
  position: absolute;
  inset: 0;
}
.admin-menu {
  width: 210px;
  text-align: left;
  border-right: none;
  overflow-y: auto;
}
.admin-logo {
  color: var(--w-logo-text);
  font-weight: 700;
  padding: 20px 16px 12px;
  letter-spacing: 0.04em;
}
.admin-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 4px rgba(0,0,0,.08);
  font-size: 15px;
  background: var(--w-surface);
  border-bottom: 1px solid var(--w-border);
}
.admin-header-right {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}
/* 侧栏未读角标：紧跟在文字后面，别把菜单项撑高 */
.ticket-badge {
  margin-left: 6px;
  vertical-align: middle;
}
.ticket-badge ::v-deep .el-badge__content {
  position: static;
  transform: none;
  display: inline-block;
}
</style>
